import React, { createContext, useContext, useEffect, useState } from "react";
import { auth } from "../lib/firebase";
import { doc, setDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../lib/firebase";
import {
  onAuthStateChanged,
  signOut as fbSignOut,
  // If you later add login:
  // signInWithEmailAndPassword
} from "firebase/auth";

const AuthContext = createContext({
  user: null,
  loading: true,
  signOut: async () => {},
});

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // Keep React state in sync with Firebase Auth
  useEffect(() => {
  const unsubscribe = onAuthStateChanged(
    auth,
    async (firebaseUser) => {
      console.log("[Auth] state changed:", firebaseUser?.email || "no user");
      setUser(firebaseUser || null);

      // Release the app immediately so a Firestore delay/error
      // cannot trap the whole portal on "Loading auth..."
      setLoading(false);

      if (firebaseUser) {
        try {
          const userRef = doc(db, "users", firebaseUser.uid);

          await setDoc(
            userRef,
            {
              lastLoginAt: serverTimestamp(),
            },
            { merge: true }
          );
        } catch (e) {
          console.error("[Auth] Failed to update lastLoginAt:", e);
        }
      }
    },
    (error) => {
      console.error("[Auth] onAuthStateChanged failed:", error);
      setUser(null);
      setLoading(false);
    }
  );

  return unsubscribe;
}, []);

  // This is the ONLY signOut your UI should call
  const signOut = async () => {
    try {
      await fbSignOut(auth);
      // Optional hard redirect to clear any stale UI state:
      // window.location.assign("/");
      console.log("[Auth] Signed out");
    } catch (err) {
      console.error("[Auth] signOut failed:", err);
      alert(err.message ?? "Sign out failed");
    }
  };

  return (
    <AuthContext.Provider value={{ user, loading, signOut }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
